import "./Footer.css";
import logo from "../../assets/logo.png";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const Footer = () => {
  const year = new Date().getFullYear();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);

  const goToQuienesSomos = () => {
    navigate("/quienes-somos");
  };

  const goToPoliticaDevolucion = () => {
    navigate("/politica-devolucion");
  };

  const goToByC = () => {
    navigate("/bases-condiciones");
  };

  const goToSeguimiento = () => {
    setShowModal(true);
  };

  const handleRedirect = () => {
    const url = `https://www.ordendereparacion.com/es/`;
    window.open(url, "_blank");
    setShowModal(false);
  };

  // Cerrar con ESC
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") {
        setShowModal(false);
      }
    };

    if (showModal) {
      document.addEventListener("keydown", handleKey);
    }

    return () => {
      document.removeEventListener("keydown", handleKey);
    };
  }, [showModal]);

  return (
    <div className="footer">
      <div className="footer-info">
        <div className="name-data">
          <img src={logo} alt="TecniPlus Logo" className="footer-logo" />
          <p>Reparación de celulares</p>
        </div>
        <p>
          En TecniPlus+ ofrecemos soluciones rápidas, confiables y de calidad
          para todo tipo de celulares. Brindamos un servicio técnico
          profesional, con repuestos de calidad y atención personalizada,
          asegurando resultados duraderos y clientes satisfechos.
        </p>
      </div>

      <div className="btn-footer">
        <button onClick={goToQuienesSomos}>Quiénes Somos</button>
        <button onClick={goToPoliticaDevolucion}>Política de Devolución</button>
        <button onClick={goToByC}>Bases y condiciones del servicio</button>
        <button id="seguimiento" onClick={goToSeguimiento}>
          Seguimiento reparación
        </button>
      </div>

      <h5>© {year} TecniPlus+. Todos los derechos reservados.</h5>

      {/* 🔥 MODAL PRO */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-icon">📱</div>

            <h2>Seguimiento de reparación</h2>

            <p>
              Para realizar el seguimiento, debes haber proporcionado tu{" "}
              <strong>DNI</strong>, <strong>nombre</strong> y{" "}
              <strong>número de contacto</strong>.
            </p>

            <p className="small-text">
              Esta información será utilizada únicamente para generar la orden
              de reparación y permitir el seguimiento de tu dispositivo.
            </p>

            <div className="modal-buttons">
              <button className="cancel" onClick={() => setShowModal(false)}>
                Cancelar
              </button>

              <button className="confirm" onClick={handleRedirect}>
                Ir al seguimiento
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;
